type AppVersion = {
  name: string;
  version: string;
};

export const useAppVersion = async (): Promise<AppVersion> => {
  const config = useRuntimeConfig();

  let version: AppVersion = {
    name: "zen-localhost",
    version: "dev",
  };

  if (config.public.deployment !== "local") {
    version = await $fetch(`${useCdnUrl()}/version.json`);
  }

  console.log("App:", version.name, "version:", version.version, "env:", config.public.deployment);
  return version;
};
